<template>
  <div>
    <div class="card card-custom card-sticky" v-if="!mostrarDetalleFicha">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label cursor-pointer">
            <span class="label label-xl label-dot label-danger mr-2"></span> Turno 2 <!--- Local (13:00 - 20:00)-->
            <small v-if="ui.estaCargandoDatos">Cargando datos de la ficha...</small>
            <small v-else-if="auth.mensajeNoAutorizadoEdicionTurno" class="text-danger">{{ auth.mensajeNoAutorizadoEdicionTurno }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <a href="#" class="btn btn-sm btn-light font-weight-bold" @click.prevent="doCargarFicha()"><i class="fa p-0 fa-sync" :class="[ui.estaCargandoDatos ? 'fa-spin ' : '']"></i></a>
        </div>
      </div>
    </div>

    <div class="card card-custom card-sticky" v-if="mostrarDetalleFicha">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label cursor-pointer" @click.prevent="$emit('update:expandirContenido', !expandirContenido)">
            <span class="label label-xl label-dot label-danger mr-2"></span> Turno 2 <!-- Local (13:00 - 20:00) -->
            <small>{{ auth.fechaInicioTurno | time }} - {{ auth.fechaFinTurno | time }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <a href="#" class="btn btn-sm font-weight-bold mr-2" :class="isDirty ? 'btn-success' : 'btn-light-success'" @click.prevent="doGuardado()"><i class="fa" :class="[ui.estaGuardando ? 'fa-spinner fa-spin p-0 fa-align-center mr-1' : 'fa-save']"></i> Guardar cambios</a>
          <a href="#" class="btn btn-sm btn-light-warning font-weight-bold" @click.prevent="$emit('update:expandirContenido', !expandirContenido)"><i class="fa p-0" :class="[expandirContenido ? 'fa-chevron-up' : 'fa-chevron-down']"></i></a>
        </div>
      </div>

      <div class="card-body px-3 px-md-9 py-4 py-md-8" v-show="expandirContenido">
        <div class="alert alert-light p-6">
          <h4 class="mb-3 font-weight-bold">Registro de Asistencia</h4>
          <form class="form" id="frm-local-ficha-t2-asistencia" @submit.prevent>
          <div class="row">
            <div class="form-group col-12 col-md-4">
              <label class="mb-1">Nombre del Observador</label>
              <input type="text" class="form-control" v-model="actual.t2ObservadorNombre" placeholder="Nombres y apellidos" autocomplete="off" required />
            </div>
            <div class="form-group col-12 col-md-4">
              <label class="mb-1">DNI</label>
              <input type="text" class="form-control" v-model="actual.t2ObservadorDni" placeholder="Número de documento de identidad" autocomplete="off" required />
            </div>
            <div class="form-group col-12 col-md-4">
              <label class="mb-1">Local de Votación</label>
              <input type="text" class="form-control" :value="localNombre" disabled />
            </div>
            <div class="form-group col-12">
              <label class="mb-1 font-weight-bold">Registro de asistencia</label>
              <div class="btn-group d-flex flex-wrap" role="group">
                <button type="button" @click.prevent="seleccionarPermitioIngreso(true)" class="btn flex-fill" :class="[actual.t2B1PermitioIngresoLocalVotacion === true ? 'btn-success' : 'btn-outline-secondary']"><i class="fa fa-door-open mr-2"></i>Ingresé al local de votación</button>
                <button type="button" @click.prevent="seleccionarPermitioIngreso(false)" class="btn flex-fill" :class="[actual.t2B1PermitioIngresoLocalVotacion === false ? 'btn-danger' : 'btn-outline-secondary']"><i class="fa fa-ban mr-2"></i>No se permitió el ingreso para la observación electoral</button>
              </div>
              <div v-if="actual.t2B1PermitioIngresoLocalVotacion === false" class="alert alert-custom alert-light-warning mt-3 mb-0 py-2">
                <i class="fa fa-info-circle mr-1"></i> Has registrado que no se permitió el ingreso. No es necesario completar el cuestionario.
              </div>
            </div>
          </div>
          </form>
        </div>
        <form v-show="registroAsistenciaCompleto" class="form" id="frm-local-ficha-t2">
          <div class="row">
            <div class="col-xl-2 d-none d-xl-block"></div>
            <div class="col-12 col-xl-8">

              <!-- BLOQUE 2: Infraestructura -->
              <div class="mt-4 mt-md-5">
                <!-- <h3 class="text-dark font-weight-bold mb-4 mb-md-10">
                  <i class="fa fa-building text-primary mr-2"></i> II. Infraestructura
                </h3> -->

                <div :class="sheetRowQClass(true, sheetT2B21Completa)">
                  <label :class="ui.colLeftClass">
                    1. ¿El local de votación cuenta con electricidad?
                  </label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2B2LocalConElectricidad = true" class="btn" :class="[actual.t2B2LocalConElectricidad === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2B2LocalConElectricidad = false" class="btn" :class="[actual.t2B2LocalConElectricidad === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetT2B31Completa)">
                  <label :class="ui.colLeftClass">
                    2. Hay presencia de:
                  </label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group flex-wrap mb-2" role="group">
                      <button type="button" @click.prevent="actual.t2B3PresenciaOnpe = !actual.t2B3PresenciaOnpe" class="btn" :class="[actual.t2B3PresenciaOnpe ? 'btn-primary' : 'btn-outline-secondary']">ONPE</button>
                      <button type="button" @click.prevent="actual.t2B3PresenciaJne = !actual.t2B3PresenciaJne" class="btn" :class="[actual.t2B3PresenciaJne ? 'btn-primary' : 'btn-outline-secondary']">JNE</button>
                      <button type="button" @click.prevent="actual.t2B3PresenciaFfaaPnp = !actual.t2B3PresenciaFfaaPnp" class="btn" :class="[actual.t2B3PresenciaFfaaPnp ? 'btn-primary' : 'btn-outline-secondary']">FFAA / PNP</button>
                      <button type="button" @click.prevent="actual.t2B3PresenciaMinisterioPublico = !actual.t2B3PresenciaMinisterioPublico" class="btn" :class="[actual.t2B3PresenciaMinisterioPublico ? 'btn-primary' : 'btn-outline-secondary']">Ministerio Público</button>
                      <button type="button" @click.prevent="actual.t2B3PresenciaDefensoriaDelPueblo = !actual.t2B3PresenciaDefensoriaDelPueblo" class="btn" :class="[actual.t2B3PresenciaDefensoriaDelPueblo ? 'btn-primary' : 'btn-outline-secondary']">Defensoría del Pueblo</button>
                    </div>
                    <div class="form-check mt-2">
                      <input class="form-check-input" type="checkbox" v-model="actual.t2B3PresenciaOtros" id="chkT2PresenciaOtros">
                      <label class="form-check-label" for="chkT2PresenciaOtros">Otros</label>
                    </div>
                    <div v-if="actual.t2B3PresenciaOtros">
                      <textarea v-model="actual.t2B3PresenciaOtrosDetalle" class="form-control mt-2" placeholder="Indicar el nombre de la entidad..." required></textarea>
                    </div>
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetT2B23Completa)">
                  <label :class="ui.colLeftClass">
                    3. ¿El local de votación esta debidamente señalizado, y cuenta con mecanismos que permitan la identificación y ubicación de la mesa de votación, accesos y salidas?
                  </label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2B2LocalSenializado = true" class="btn" :class="[actual.t2B2LocalSenializado === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2B2LocalSenializado = false" class="btn" :class="[actual.t2B2LocalSenializado === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2B2LocalSenializado === false">
                      <textarea v-model="actual.t2B2LocalSenializadoDetalle" class="form-control mt-2" placeholder="Señale brevemente por qué..." required></textarea>
                    </div>
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetT2B22Completa)">
                  <label :class="ui.colLeftClass">
                    4. ¿Existen mecanismos de acceso para personas con discapacidad, embarazadas y/o adultos mayores al local de votación?
                  </label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2B2AccesoPersonasVulnerables = true" class="btn" :class="[actual.t2B2AccesoPersonasVulnerables === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2B2AccesoPersonasVulnerables = false" class="btn" :class="[actual.t2B2AccesoPersonasVulnerables === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                  </div>
                </div>


              </div>

              <div :class="sheetRowQClass(true, sheetT2B33Completa)">
                <label :class="ui.colLeftClass">
                  5. ¿Observas algún tipo de propaganda electoral en el local de votación?
                </label>
                <div :class="ui.colRightClass">
                  <div class="btn-group" role="group">
                    <button type="button" @click.prevent="actual.t2B3PropagandaEnLocal = true" class="btn" :class="[actual.t2B3PropagandaEnLocal === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                    <button type="button" @click.prevent="limpiarPropagandaLocal()" class="btn" :class="[actual.t2B3PropagandaEnLocal === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                  </div>
                  <div v-if="actual.t2B3PropagandaEnLocal === true" class="mt-2">
                    <label class="mb-1">Organización política:</label>
                    <div class="btn-group d-flex flex-wrap" role="group">
                      <button v-for="partido in partidosNacionales" :key="partido.parametroId" type="button" @click.prevent="togglePartidoCsv('t2B3PropagandaEnLocalOrganizacionParamIds', partido.parametroId)" class="btn btn-sm" :class="[isPartidoSelected('t2B3PropagandaEnLocalOrganizacionParamIds', partido.parametroId) ? 'btn-primary' : 'btn-outline-secondary']">
                        <img :src="getImagenPartidoPolitico(partido.parametroId)" style="height:20px;width:auto;vertical-align:middle;" class="mr-1" />
                        {{ partido.descripcion }}
                      </button>
                    </div>
                    <small v-if="parsePartidoIds(actual.t2B3PropagandaEnLocalOrganizacionParamIds).length === 0" class="text-danger d-block mt-1">Selecciona al menos una organización política.</small>
                    <textarea required v-model="actual.t2B3PropagandaEnLocalDetalle" class="form-control mt-2" placeholder="Señale brevemente el detalle..."></textarea>
                  </div>
                </div>
              </div>

              <!-- BLOQUE 3: Entorno Electoral -->
              <div class="mt-4 mt-md-5">
                <!-- <h3 class="text-dark font-weight-bold mb-4 mb-md-10">
                  <i class="fa fa-vote-yea text-primary mr-2"></i> III. Entorno Electoral
                </h3> -->

                <div :class="sheetRowQClass(true, sheetT2B32Completa)">
                  <label :class="ui.colLeftClass">
                    6. En el local de votación, ¿se ha habilitado un área para el SUFRAGIO en el primer piso para personas con discapacidad o adultos mayores?
                  </label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2B3AreaSufragioPrimerPiso = true" class="btn" :class="[actual.t2B3AreaSufragioPrimerPiso === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2B3AreaSufragioPrimerPiso = false" class="btn" :class="[actual.t2B3AreaSufragioPrimerPiso === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2B3AreaSufragioPrimerPiso === false">
                      <textarea v-model="actual.t2B3AreaSufragioPrimerPisoDetalle" class="form-control mt-2" placeholder="Señale en qué piso se ubica..." required></textarea>
                    </div>
                  </div>
                </div>


              </div>

              <!-- BLOQUE 4: Incidencias -->
              <div class="mt-4 mt-md-5">
                <!-- <h3 class="text-dark font-weight-bold mb-4 mb-md-10">
                  <i class="fa fa-exclamation-triangle text-primary mr-2"></i> IV. Incidencias
                </h3> -->

                <div :class="sheetRowQClass(true, sheetT2B41Completa)">
                  <label :class="ui.colLeftClass">
                    7. ¿Se presentó/produjo algún incidente que limita o impida el ejercicio de tus funciones como observador/a electoral?
                  </label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2B4IncidenteLimitaLaborObservador = true" class="btn" :class="[actual.t2B4IncidenteLimitaLaborObservador === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2B4IncidenteLimitaLaborObservador = false" class="btn" :class="[actual.t2B4IncidenteLimitaLaborObservador === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2B4IncidenteLimitaLaborObservador === true">
                      <textarea v-model="actual.t2B4IncidenteLimitaLaborObservadorDetalle" class="form-control mt-2" placeholder="Señale brevemente el detalle..." required></textarea>
                    </div>
                    <div v-if="actual.t2B4IncidenteLimitaLaborObservador === true" class="alert alert-custom alert-light-warning mt-2 mb-0 py-2">
                      <i class="fa fa-bell mr-1"></i> Recuerda que también debes registrar la información en el botón de alerta.
                    </div>
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetT2B42Completa)">
                  <label :class="ui.colLeftClass">
                    8. ¿Se ha detectado algún acto de intimidación, coacción, agresión o violencia que impida el ejercicio del voto ciudadano en tu local de votación?
                  </label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2B4ActoIntimidacionOViolencia = true" class="btn" :class="[actual.t2B4ActoIntimidacionOViolencia === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2B4ActoIntimidacionOViolencia = false" class="btn" :class="[actual.t2B4ActoIntimidacionOViolencia === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2B4ActoIntimidacionOViolencia === true">
                      <textarea v-model="actual.t2B4ActoIntimidacionOViolenciaDetalle" class="form-control mt-2" placeholder="Señale brevemente el detalle..." required></textarea>
                    </div>
                    <div v-if="actual.t2B4ActoIntimidacionOViolencia === true" class="alert alert-custom alert-light-warning mt-2 mb-0 py-2">
                      <i class="fa fa-bell mr-1"></i> Recuerda que también debes registrar la información en el botón de alerta.
                    </div>
                  </div>
                </div>
              </div>

              <!-- CIERRE -->
              <div class="mt-4 mt-md-5">
                <!-- <h3 class="text-dark font-weight-bold mb-4 mb-md-10">
                  <i class="fa fa-flag-checkered text-primary mr-2"></i> Cierre del Local
                </h3> -->

                <div :class="sheetRowQClass(true, sheetT2C1Completa)">
                  <label :class="ui.colLeftClass">
                    9. Señale la hora en la que cerró el local de votación:
                  </label>
                  <div :class="ui.colRightClass">
                    <input type="time" class="form-control" v-model="actual.t2CHoraCierreLocal" />
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetT2C2Completa)">
                  <label :class="ui.colLeftClass">
                    10. Después del cierre de puertas ¿quedaron personas dentro del local de votación esperando votar?
                  </label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2CQuedaronPersonasEsperandoVotar = true" class="btn" :class="[actual.t2CQuedaronPersonasEsperandoVotar === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="limpiarCierre()" class="btn" :class="[actual.t2CQuedaronPersonasEsperandoVotar === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                  </div>
                </div>

                <div v-if="actual.t2CQuedaronPersonasEsperandoVotar === true" :class="sheetRowQClass(true, sheetT2C3Completa)">
                  <label :class="ui.colLeftClass">
                    11. ¿Se permitió a estas personas votar?
                  </label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2CSePermitioVotarTrasCierre = true" class="btn" :class="[actual.t2CSePermitioVotarTrasCierre === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2CSePermitioVotarTrasCierre = false" class="btn" :class="[actual.t2CSePermitioVotarTrasCierre === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-2 d-none d-xl-block"></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { sheetBoolAnswered, sheetNonEmpty } from "@/helpers/sheetQuestion.js";

export default {
  name: "ficha-turno-2-local-2026",
  props: {
    localVotacionId: { type: Number },
    procesoElectoralId: { type: Number },
    expandirContenido: { type: Boolean },
    intervaloAutoGuardado: { type: Number },
  },
  data: () => ({
    auth: {
      autorizadoEdicionTurno: null,
      mensajeNoAutorizadoEdicionTurno: null,
      fechaInicioTurno: null,
      fechaFinTurno: null,
    },
    ui: {
      colLeftClass: "col-12 col-md-5 col-form-label",
      colRightClass: "col-12 col-md-7",
      estaGuardando: false,
      estaCargandoDatos: false,
      tieneCargaInicial: false,
    },
    temporizadorGuardado: null,
    localNombre: null,
    actual: {
      t2ObservadorNombre: null,
      t2ObservadorDni: null,
      t2B1PermitioIngresoLocalVotacion: null,
      t2B2LocalConElectricidad: null,
      t2B2AccesoPersonasVulnerables: null,
      t2B2LocalSenializado: null,
      t2B2LocalSenializadoDetalle: null,
      t2B3PresenciaOnpe: null,
      t2B3PresenciaJne: null,
      t2B3PresenciaFfaaPnp: null,
      t2B3PresenciaMinisterioPublico: null,
      t2B3PresenciaDefensoriaDelPueblo: null,
      t2B3PresenciaOtros: null,
      t2B3PresenciaOtrosDetalle: null,
      t2B3AreaSufragioPrimerPiso: null,
      t2B3AreaSufragioPrimerPisoDetalle: null,
      t2B3PropagandaEnLocal: null,
      t2B3PropagandaEnLocalOrganizacionParamId: null,
      t2B3PropagandaEnLocalOrganizacionParamIds: null,
      t2B3PropagandaEnLocalDetalle: null,
      t2B4IncidenteLimitaLaborObservador: null,
      t2B4IncidenteLimitaLaborObservadorDetalle: null,
      t2B4ActoIntimidacionOViolencia: null,
      t2B4ActoIntimidacionOViolenciaDetalle: null,
      t2CHoraCierreLocal: null,
      t2CQuedaronPersonasEsperandoVotar: null,
      t2CSePermitioVotarTrasCierre: null,
    },
    guardado: {
      t2ObservadorNombre: null,
      t2ObservadorDni: null,
      t2B1PermitioIngresoLocalVotacion: null,
      t2B2LocalConElectricidad: null,
      t2B2AccesoPersonasVulnerables: null,
      t2B2LocalSenializado: null,
      t2B2LocalSenializadoDetalle: null,
      t2B3PresenciaOnpe: null,
      t2B3PresenciaJne: null,
      t2B3PresenciaFfaaPnp: null,
      t2B3PresenciaMinisterioPublico: null,
      t2B3PresenciaDefensoriaDelPueblo: null,
      t2B3PresenciaOtros: null,
      t2B3PresenciaOtrosDetalle: null,
      t2B3AreaSufragioPrimerPiso: null,
      t2B3AreaSufragioPrimerPisoDetalle: null,
      t2B3PropagandaEnLocal: null,
      t2B3PropagandaEnLocalOrganizacionParamId: null,
      t2B3PropagandaEnLocalOrganizacionParamIds: null,
      t2B3PropagandaEnLocalDetalle: null,
      t2B4IncidenteLimitaLaborObservador: null,
      t2B4IncidenteLimitaLaborObservadorDetalle: null,
      t2B4ActoIntimidacionOViolencia: null,
      t2B4ActoIntimidacionOViolenciaDetalle: null,
      t2CHoraCierreLocal: null,
      t2CQuedaronPersonasEsperandoVotar: null,
      t2CSePermitioVotarTrasCierre: null,
    },
    partidos: [],
  }),
  computed: {
    partidosNacionales() {
      return (this.partidos || []).filter(p => p.regionId == 0);
    },
    isDirty() {
      return JSON.stringify(this.actual) != JSON.stringify(this.guardado);
    },
    mostrarDetalleFicha() {
      return this.ui.tieneCargaInicial && !!this.auth.autorizadoEdicionTurno;
    },
    datosAsistenciaValidos() {
      var nombre = (this.actual.t2ObservadorNombre || "").toString().trim();
      var dni = (this.actual.t2ObservadorDni || "").toString().trim();
      return nombre.length > 0 && dni.length > 0;
    },
    registroAsistenciaCompleto() {
      return this.datosAsistenciaValidos && this.actual.t2B1PermitioIngresoLocalVotacion === true;
    },
    sheetT2B21Completa() {
      return sheetBoolAnswered(this.actual.t2B2LocalConElectricidad);
    },
    sheetT2B22Completa() {
      return sheetBoolAnswered(this.actual.t2B2AccesoPersonasVulnerables);
    },
    sheetT2B23Completa() {
      const x = this.actual.t2B2LocalSenializado;
      if (!sheetBoolAnswered(x)) return false;
      if (x === false) return sheetNonEmpty(this.actual.t2B2LocalSenializadoDetalle);
      return true;
    },
    sheetT2B31Completa() {
      const a = this.actual;
      const presencia = !!(
        a.t2B3PresenciaOnpe ||
        a.t2B3PresenciaJne ||
        a.t2B3PresenciaFfaaPnp ||
        a.t2B3PresenciaMinisterioPublico ||
        a.t2B3PresenciaDefensoriaDelPueblo ||
        a.t2B3PresenciaOtros
      );
      if (!presencia) return false;
      if (a.t2B3PresenciaOtros && !sheetNonEmpty(a.t2B3PresenciaOtrosDetalle)) return false;
      return true;
    },
    sheetT2B32Completa() {
      const x = this.actual.t2B3AreaSufragioPrimerPiso;
      if (!sheetBoolAnswered(x)) return false;
      if (x === false) return sheetNonEmpty(this.actual.t2B3AreaSufragioPrimerPisoDetalle);
      return true;
    },
    sheetT2B33Completa() {
      const x = this.actual.t2B3PropagandaEnLocal;
      if (!sheetBoolAnswered(x)) return false;
      if (x === true) {
        if (this.parsePartidoIds(this.actual.t2B3PropagandaEnLocalOrganizacionParamIds).length === 0) return false;
        return sheetNonEmpty(this.actual.t2B3PropagandaEnLocalDetalle);
      }
      return true;
    },
    sheetT2B41Completa() {
      const x = this.actual.t2B4IncidenteLimitaLaborObservador;
      if (!sheetBoolAnswered(x)) return false;
      if (x === true) return sheetNonEmpty(this.actual.t2B4IncidenteLimitaLaborObservadorDetalle);
      return true;
    },
    sheetT2B42Completa() {
      const x = this.actual.t2B4ActoIntimidacionOViolencia;
      if (!sheetBoolAnswered(x)) return false;
      if (x === true) return sheetNonEmpty(this.actual.t2B4ActoIntimidacionOViolenciaDetalle);
      return true;
    },
    sheetT2C1Completa() {
      return sheetNonEmpty(this.actual.t2CHoraCierreLocal);
    },
    sheetT2C2Completa() {
      const q = this.actual.t2CQuedaronPersonasEsperandoVotar;
      if (!sheetBoolAnswered(q)) return false;
      if (q === true) return sheetBoolAnswered(this.actual.t2CSePermitioVotarTrasCierre);
      return true;
    },
    sheetT2C3Completa() {
      return sheetBoolAnswered(this.actual.t2CSePermitioVotarTrasCierre);
    },
  },
  methods: {
    sheetRowQClass(aplica, completa) {
      if (!aplica) return ["form-group", "row"];
      return ["form-group", "row", "sheet-question", completa ? "sheet-question--completada" : "sheet-question--pendiente"];
    },
    fetchPartidosPoliticos() {
      this.$http.get(this.apiRoute("Parameter", "ListParametrosPoliticos"), { params: { Id: this.localVotacionId } })
        .then(function (response) { this.partidos = response.body.data; });
    },
    getImagenPartidoPolitico(partidoPoliticoParamId) {
      var partido = this.partidos.find(x => x.parametroId == partidoPoliticoParamId);
      var imagen = partido ? partido.imagen : "app-partidos/_no-image.png";
      return `${this.apiResource(imagen)}`;
    },
    parsePartidoIds(csv) {
      if (!csv) return [];
      return csv.toString().split(",").map(s => parseInt(s, 10)).filter(n => !isNaN(n));
    },
    isPartidoSelected(campo, parametroId) {
      return this.parsePartidoIds(this.actual[campo]).indexOf(parametroId) !== -1;
    },
    togglePartidoCsv(campo, parametroId) {
      var ids = this.parsePartidoIds(this.actual[campo]);
      var idx = ids.indexOf(parametroId);
      if (idx === -1) ids.push(parametroId);
      else ids.splice(idx, 1);
      this.actual[campo] = ids.length ? ids.join(",") : null;
    },
    validarRegistroAsistencia() {
      return this.isFormValid("frm-local-ficha-t2-asistencia");
    },
    hayDatosCuestionario() {
      var a = this.actual;
      return (
        a.t2B2LocalConElectricidad !== null ||
        a.t2B2AccesoPersonasVulnerables !== null ||
        a.t2B2LocalSenializado !== null ||
        !!a.t2B2LocalSenializadoDetalle ||
        a.t2B3PresenciaOnpe !== null ||
        a.t2B3PresenciaJne !== null ||
        a.t2B3PresenciaFfaaPnp !== null ||
        a.t2B3PresenciaMinisterioPublico !== null ||
        a.t2B3PresenciaDefensoriaDelPueblo !== null ||
        a.t2B3PresenciaOtros !== null ||
        !!a.t2B3PresenciaOtrosDetalle ||
        a.t2B3AreaSufragioPrimerPiso !== null ||
        !!a.t2B3AreaSufragioPrimerPisoDetalle ||
        a.t2B3PropagandaEnLocal !== null ||
        !!a.t2B3PropagandaEnLocalOrganizacionParamIds ||
        !!a.t2B3PropagandaEnLocalDetalle ||
        a.t2B4IncidenteLimitaLaborObservador !== null ||
        !!a.t2B4IncidenteLimitaLaborObservadorDetalle ||
        a.t2B4ActoIntimidacionOViolencia !== null ||
        !!a.t2B4ActoIntimidacionOViolenciaDetalle ||
        !!a.t2CHoraCierreLocal ||
        a.t2CQuedaronPersonasEsperandoVotar !== null ||
        a.t2CSePermitioVotarTrasCierre !== null
      );
    },
    resetCuestionarioTurno() {
      var a = this.actual;
      a.t2B2LocalConElectricidad = null;
      a.t2B2AccesoPersonasVulnerables = null;
      a.t2B2LocalSenializado = null;
      a.t2B2LocalSenializadoDetalle = null;
      a.t2B3PresenciaOnpe = null;
      a.t2B3PresenciaJne = null;
      a.t2B3PresenciaFfaaPnp = null;
      a.t2B3PresenciaMinisterioPublico = null;
      a.t2B3PresenciaDefensoriaDelPueblo = null;
      a.t2B3PresenciaOtros = null;
      a.t2B3PresenciaOtrosDetalle = null;
      a.t2B3AreaSufragioPrimerPiso = null;
      a.t2B3AreaSufragioPrimerPisoDetalle = null;
      a.t2B3PropagandaEnLocal = null;
      a.t2B3PropagandaEnLocalOrganizacionParamId = null;
      a.t2B3PropagandaEnLocalOrganizacionParamIds = null;
      a.t2B3PropagandaEnLocalDetalle = null;
      a.t2B4IncidenteLimitaLaborObservador = null;
      a.t2B4IncidenteLimitaLaborObservadorDetalle = null;
      a.t2B4ActoIntimidacionOViolencia = null;
      a.t2B4ActoIntimidacionOViolenciaDetalle = null;
      a.t2CHoraCierreLocal = null;
      a.t2CQuedaronPersonasEsperandoVotar = null;
      a.t2CSePermitioVotarTrasCierre = null;
    },
    seleccionarPermitioIngreso(valor) {
      if (this.actual.t2B1PermitioIngresoLocalVotacion === valor) return;
      if (!this.validarRegistroAsistencia() || !this.datosAsistenciaValidos) {
        this.$bvToast.toast("Completa el Nombre del Observador y DNI antes de continuar.", { title: "Registro de Asistencia", autoHideDelay: 5000, variant: "warning", appendToast: false, solid: true });
        return;
      }
      if (valor === false && this.hayDatosCuestionario()) {
        var vm = this;
        this.$bvModal.msgBoxConfirm(
          "Se borrarán todos los datos ya registrados en el cuestionario de esta ficha. ¿Deseas continuar?",
          {
            title: "Confirmar cambio",
            okTitle: "Sí, borrar y continuar",
            cancelTitle: "Cancelar",
            okVariant: "danger",
            centered: true,
          }
        ).then(function (confirmado) {
          if (!confirmado) return;
          vm.resetCuestionarioTurno();
          vm.$set(vm.actual, "t2B1PermitioIngresoLocalVotacion", false);
        });
        return;
      }
      this.$set(this.actual, "t2B1PermitioIngresoLocalVotacion", valor);
    },
    limpiarPropagandaLocal() {
      this.actual.t2B3PropagandaEnLocal = false;
      this.actual.t2B3PropagandaEnLocalOrganizacionParamId = null;
      this.actual.t2B3PropagandaEnLocalOrganizacionParamIds = null;
      this.actual.t2B3PropagandaEnLocalDetalle = null;
    },
    limpiarCierre() {
      this.actual.t2CQuedaronPersonasEsperandoVotar = false;
      this.actual.t2CSePermitioVotarTrasCierre = null;
    },
    inicializarGuardado() {
      if (!this.intervaloAutoGuardado || this.intervaloAutoGuardado <= 0) return;
      if (!this.ui.tieneCargaInicial || this.ui.estaCargandoDatos) return;
      if (!this.auth.autorizadoEdicionTurno) return;
      var vm = this;
      clearTimeout(this.temporizadorGuardado);
      this.temporizadorGuardado = setTimeout(function () {
        if (!vm.ui.estaCargandoDatos && !vm.ui.estaGuardando && vm.isDirty) vm.doGuardado(true);
      }, this.intervaloAutoGuardado);
    },
    actualizarBaseDiferente(propiedad, fichaActual, fichaGuardado, fichaActualizada) {
      var vActual = JSON.stringify(fichaActual[propiedad]);
      var vGuardado = JSON.stringify(fichaGuardado[propiedad]);
      var vActualizado = JSON.stringify(fichaActualizada[propiedad]);
      return (vActual == vGuardado && vGuardado != vActualizado) ? fichaActualizada[propiedad] : fichaActual[propiedad];
    },
    doCargarFicha: async function () {
      this.ui.estaCargandoDatos = true;
      var model = { localVotacionId: this.localVotacionId, procesoElectoralId: this.procesoElectoralId };

      await this.$http.post(this.apiRoute("Sheet", "GetFichaTurnoDos"), model).then(function (response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          var ficha = response.body.data.ficha;
          var tempActual = this.cloneObject(this.actual);
          var tempGuardado = this.cloneObject(this.guardado);

          var campos = Object.keys(tempActual);
          campos.forEach(c => { tempActual[c] = this.actualizarBaseDiferente(c, tempActual, tempGuardado, ficha); });

          this.actual = this.cloneObject(tempActual);
          this.guardado = this.cloneObject(this.actual);
          this.auth = response.body.data.auth;
          this.localNombre = response.body.data.localNombre;
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.ui.tieneCargaInicial = true;
      this.ui.estaCargandoDatos = false;
    },
    doGuardado: async function (omitirNotificacion) {
      if (this.ui.estaGuardando) return;
      if (omitirNotificacion == true && !this.datosAsistenciaValidos) return false;
      if (!this.validarRegistroAsistencia() || !this.datosAsistenciaValidos) {
        if (omitirNotificacion != true) this.$bvToast.toast("Completa el Nombre del Observador y DNI antes de guardar.", { title: "Ficha Local - Turno 2", autoHideDelay: 5000, variant: "warning", appendToast: false, solid: true });
        return false;
      }
      if (this.actual.t2B3PropagandaEnLocal === true && this.parsePartidoIds(this.actual.t2B3PropagandaEnLocalOrganizacionParamIds).length === 0) {
        if (omitirNotificacion != true) this.$bvToast.toast("Selecciona al menos una organización política para la pregunta de propaganda electoral.", { title: "Ficha Local - Turno 2", autoHideDelay: 5000, variant: "warning", appendToast: false, solid: true });
        return false;
      }
      if (!this.isFormValid("frm-local-ficha-t2")) {
        if (omitirNotificacion != true) this.$bvToast.toast("Hay campos con valores incorrectos.", { title: "Ficha Local - Turno 2", autoHideDelay: 5000, variant: "warning", appendToast: false, solid: true });
        return false;
      }

      var actualClone = this.cloneObject(this.actual);
      var model = this.cloneObject(this.actual);
      model.localVotacionId = this.localVotacionId;
      model.procesoElectoralId = this.procesoElectoralId;

      var guardadoExitoso = false;
      this.ui.estaGuardando = true;
      await this.$http.post(this.apiRoute("Sheet", "EditFichaTurnoDos"), model).then(function (response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          this.guardado = actualClone;
          if (omitirNotificacion != true) this.$bvToast.toast("Los cambios se han guardado correctamente.", { title: "Ficha Local - Turno 2", autoHideDelay: 5000, variant: "success", appendToast: false, solid: true });
          guardadoExitoso = true;
          this.doCargarFicha();
          this.$notifyHub.notificarCambioFicha(this.procesoElectoralId, this.localVotacionId, 2);
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.ui.estaGuardando = false;
      return guardadoExitoso;
    },
  },
  watch: {
    actual: {
      deep: true,
      handler() {
        if (this.intervaloAutoGuardado && this.intervaloAutoGuardado > 0 && this.ui.tieneCargaInicial && !this.ui.estaCargandoDatos && this.auth.autorizadoEdicionTurno) {
          this.inicializarGuardado();
        }
      },
    },
  },
  mounted() {
    this.initParsley();
    this.fetchPartidosPoliticos();
    this.doCargarFicha();
  },
  beforeDestroy() {
    clearTimeout(this.temporizadorGuardado);
  },
};
</script>

<style scoped>
.card-body .btn-outline-secondary {
  background-color: #fff;
}
</style>
